import { useEffect } from 'react';

const ImpersonateComponent = (props) => {
  useEffect(() => {
    const { access_token } = props.match.params;

    // ambil query param
    const searchParams = new URLSearchParams(props.location.search);
    const redirectTo = searchParams.get('redirect_to') || '/';

    localStorage.setItem('access_token', access_token);
    localStorage.setItem('token_type', 'Bearer');
    localStorage.setItem('expires_in', 1790000);

    setTimeout(() => {
      window.location.href = redirectTo;
    }, 1000);
  }, []);

  return null;
};

export default ImpersonateComponent;
